// Declare global types for Google Analytics and Tag Manager
declare global {
  interface Window {
    dataLayer: any[]
    gtag: (...args: any[]) => void
  }
}

/**
 * Initialize Google Tag Manager
 */
export function initGTM() {
  // Google Tag Manager script
  const gtmScript = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-TC8RDV74');`

  const script = document.createElement('script')
  script.innerHTML = gtmScript
  document.head.insertBefore(script, document.head.firstChild)

  // Add noscript iframe for GTM
  const noscript = document.createElement('noscript')
  const iframe = document.createElement('iframe')
  iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-TC8RDV74'
  iframe.height = '0'
  iframe.width = '0'
  iframe.style.display = 'none'
  iframe.style.visibility = 'hidden'
  noscript.appendChild(iframe)
  document.body.insertBefore(noscript, document.body.firstChild)
}

/**
 * Initialize Google Analytics (gtag.js)
 */
export function initGoogleAnalytics() {
  // Load gtag.js script
  const gtagScript = document.createElement('script')
  gtagScript.async = true
  gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-RH10H7P4LR'
  document.head.appendChild(gtagScript)

  // Initialize gtag
  const inlineScript = document.createElement('script')
  inlineScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-RH10H7P4LR');
  `
  document.head.appendChild(inlineScript)
}

/**
 * Initialize all tracking scripts
 */
export function initAnalytics() {
  if (typeof window === 'undefined') return

  initGTM()
  initGoogleAnalytics()
}
